import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import Backgroundimage from "../components/Backgroundimage";
import NavigationForHome from "../components/NavigationForHome";
import Footer from "../components/Footer";


let HomePage = () => {



return (

<div>
    <Backgroundimage />
    <NavigationForHome />
    <h1>Hello World</h1>
    <Footer />
  </div>
  )
  
};

export default HomePage;
